import * as React from 'react';
import { PaginationItem, PaginationLink } from '@/web/components/ui/pagination';
import type { PaginationPage } from '@/types';

export interface PaginationNavItemProps {
  page: PaginationPage;
  categoryId: string;
  subcategoryId?: string | null | undefined;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export function PaginationNavItem(props: PaginationNavItemProps): React.ReactElement {
  const { page, label, isSelected } = props.page;

  let navUrl = `/products/${props.categoryId}?pageNo=${page}`;
  if (props.subcategoryId) {
    navUrl = `/products/${props.categoryId}/${props.subcategoryId}?pageNo=${page}`;
  }

  return (
    <PaginationItem className="list-none">
      <PaginationLink to={navUrl} isActive={isSelected} onClick={props.onClick}>
        {label}
      </PaginationLink>
    </PaginationItem>
  );
}
